import React from 'react';
import { Col, Container, FormGroup, Label, Row } from 'reactstrap';
import { Field, Fields } from 'redux-form';
import { compact } from 'underscore';

// components
import BufferedInput from '../../../components/form/field/buffered-input';
import LotTypeFilter from '../../../components/form/filter/lot-type-filter';
import LandImprovementFilter from '../../../components/form/filter/land-improvement-filter';
import PriceFilter from '../../../components/form/filter/price-filter';
import { LocationTypeAheadField } from '../../../components/form/field/location-typeahead';
import WaterfrontTypeFilter from '../../../components/form/filter/waterfront-type-filter';
import SQFTFilter from '../../../components/form/filter/sqft-filter';
import PreferenceFilter from '../../../components/form/filter/preference-filter';

// modules
import BS from '../../../theme/Bootstrap';
import formStyles from '../../../components/form/form.module.scss';
import styles from '../../Containers.module.scss';

const LandAdvancedSearch = props => {
  return (
    <Container className={`${BS.alignItemsStart}`}>
      <Row>
        <Col xs={12} md={4}>
          <FormGroup>
            <Label className={styles.label} for="address">
              Location:
            </Label>
            <LocationTypeAheadField name="address" propertyClass="land" />
          </FormGroup>
          <FormGroup className={formStyles.inputTextCenter}>
            <Label className={styles.label} for="minArea">
              Acres:
            </Label>
            <Fields names={['minArea', 'maxArea']} component={SQFTFilter} />
          </FormGroup>
          <FormGroup className={formStyles.inputTextCenter}>
            <Label className={styles.label} for="minPrice">
              Price:
            </Label>
            <Fields
              names={['minPrice', 'maxPrice']}
              component={PriceFilter}
              showSelects
            />
          </FormGroup>
        </Col>
      </Row>
      <FormGroup row>
        <Col xs={12} md={4}>
          <Label className={styles.label} for="location">
            MLS ID:
          </Label>
          <div>
            <Field
              name="mlsNumber"
              type="text"
              placeholder="MLS ID"
              component={BufferedInput}
            />
          </div>
        </Col>
      </FormGroup>
      <FormGroup>
        <Label className={styles.label} for="propertyType">
          Lot Type:
        </Label>
        <div>
          <Field
            format={value => {
              return compact((value || '').trim().split(','));
            }}
            normalize={value => {
              return value.join(',');
            }}
            name="propertyType"
            component={LotTypeFilter}
          />
        </div>
      </FormGroup>
      <Row>
        <Col xs={12} md={4}>
          <FormGroup>
            <Label className={styles.label} for="waterfrontYN">
              Waterfront:
            </Label>
            <Field name="waterfrontYN" component={PreferenceFilter} />
          </FormGroup>
        </Col>
      </Row>
      <FormGroup>
        <Label className={styles.label} for="waterfront">
          Waterfront Description:
        </Label>
        <div>
          <Field
            format={value => {
              return compact((value || '').trim().split(','));
            }}
            normalize={value => {
              return value.join(',');
            }}
            name="waterfront"
            component={WaterfrontTypeFilter}
          />
        </div>
      </FormGroup>
      <FormGroup>
        <Label className={styles.label} for="landImprovement">
          Land Improvements:
        </Label>
        <div>
          <Field
            format={value => {
              return compact((value || '').trim().split(','));
            }}
            normalize={value => {
              return value.join(',');
            }}
            name="landImprovement"
            component={LandImprovementFilter}
          />
        </div>
      </FormGroup>
    </Container>
  );
};

export default LandAdvancedSearch;



// WEBPACK FOOTER //
// ./src/containers/PropertySearch/AdvancedSearch/LandAdvancedSearch.js